<template>
  <page-header-wrapper @back="back">
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户昵称')" prop="inviteeName">
                <a-input v-model="queryParam.inviteeName" :maxLength="32" :placeholder="$t('请输入')+$t('用户昵称')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('手机号')" prop="inviteePhone">
                <a-input v-model="queryParam.inviteePhone" :maxLength="32" :placeholder="$t('请输入')+$t('手机号')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('入驻时间')" prop="joinTime">
                <a-date-picker style="width: 100%" v-model="queryParam.joinTime" format="YYYY-MM-DD HH:mm:ss" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          style="margin-bottom: 24px;"
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%', y: tableScrollY }"
      >
        <span slot="inviteStatus" slot-scope="text">
          {{ text === 1 ? $t('正常') : $t('作废') }}
        </span>
        <span slot="joinTime" slot-scope="text, record">
          {{ parseTime(record.joinTime) }}
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUnionInviteMember } from '@/api/union/unionInviteMember'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'UnionInviteMember',
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      // 高级搜索 展开/关闭
      advanced: false,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        allianceId: undefined,
        inviterUserId: undefined,
        inviteeUserId: undefined,
        inviteeName: undefined,
        inviteePhone: undefined,
        inviteStatus: undefined,
        joinTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('用户昵称'),
          dataIndex: 'inviteeName',
          ellipsis: true,
          width: '120px',
          align: 'center',
          fixed: 'left'
        },
        {
          title: this.$t('手机号'),
          dataIndex: 'inviteePhone',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('邀请人'),
          dataIndex: 'inviterName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('邀请状态'),
          dataIndex: 'inviteStatus',
          scopedSlots: { customRender: 'inviteStatus' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('入驻时间'),
          dataIndex: 'joinTime',
          scopedSlots: { customRender: 'joinTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('贡献佣金'),
          dataIndex: 'contribIncome',
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    const id = this.$route.query && this.$route.query.allianceId
    if (id) {
      this.queryParam.allianceId = id
    }
    this.getList()
  },
  watch: {},
  methods: {
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询联盟邀请成员（邀请人员）列表 */
    getList() {
      this.loading = true
      pageUnionInviteMember(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        allianceId: this.$route.query && this.$route.query.allianceId,
        inviterUserId: undefined,
        inviteeUserId: undefined,
        inviteeName: undefined,
        inviteePhone: undefined,
        inviteStatus: undefined,
        joinTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    /** 关闭按钮 */
    back() {
      this.$router.push({ path: '/union/union/alliance' })
    }
  }
}
</script>
